import { TableHead, TableRow, TableCell, Typography } from '@mui/material'
import type { FC } from 'react'

const TableHeader: FC = () => (
  <TableHead>
    <TableRow>
      <TableCell>
        <Typography variant="subtitle2">Name</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="subtitle2">Escalation Reason</Typography>
      </TableCell>
      <TableCell width={110}>
        <Typography variant="subtitle2"></Typography>
      </TableCell>
    </TableRow>
  </TableHead>
)

export default TableHeader
